import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDto } from '@api/core';
import { checkShellAccess, currentUser$ } from '@stillmandigital/common';
import { MarketMakingPlatformsStore } from 'app/market-making/shared/market-making-platforms.store';
import { map, of, switchMap } from 'rxjs';

export const adminShellGuard: CanActivateFn = () => {
  const platformsStore = inject(MarketMakingPlatformsStore);
  const router = inject(Router);

  return currentUser$<UserDto>().pipe(
    switchMap(user => {
      const redirect = resolve(user, router);
      return redirect === true ? platformsStore.platformsReady().pipe(map(() => true)) : of(redirect);
    }),
  );
};

function resolve(user: UserDto | undefined, router: Router): boolean | ReturnType<Router['createUrlTree']> {
  const access = checkShellAccess(user, router);
  if (access !== true) {
    return access;
  }
  if (user?.role === UserDto.RoleEnum.AdminCompliance) {
    return router.createUrlTree(['/compliance/client-report']);
  }
  return true;
}
